import { Component } from '@angular/core';

/**
 * @title Basic datepicker
 */
@Component({
    selector: 'datepicker-example',
    templateUrl: './datepicker.component.html',
    standalone: false
})
export class DatepickerExample {}